import React, { useContext, useEffect, useState } from 'react'
import styles from '../styles.module.scss'
import { TestContext } from '../../../utils/context'
import Loader from 'react-loader';


const FinalWindow = () => {
  
  const {data, closeTestHandler, getStatistic, statistic, testId, can_try, repeatHandler} = useContext(TestContext)

  const [loading, setLoading] = useState(false)

  const getStatisticAction = async () => {
    setLoading(true)
    await getStatistic(testId)
    setLoading(false)
  }

  useEffect(() => {
    getStatisticAction()
  }, [])
  
  const percentage = `${Math.round(statistic?.user_correct_percentage, 2) || ''}%`


  return (
    <div>
      <div className={styles.finalWindow}>
        {loading && <Loader/>}
        {!loading &&
          <>
            {/* <h1>Тест завершен</h1> */}
            {/* <h1>{percentage}</h1> */}
            <div>
              <p>Всего вопросов: <span>{statistic?.count_all_question}</span></p>
              <p>Верных ответов: <span>{statistic?.correct_question_answers}</span></p>
              <p>Вопросов с ручной проверкой: <span>{statistic?.text_question}</span></p>
            </div>
          </>
        } 
      </div>
      <div className={styles.buttonsBlock}>
        <button onClick={closeTestHandler}>Отправить на проверку</button>
        {can_try && <button onClick={repeatHandler}>Повторить попытку</button>}
      </div>
    </div>
  )
}

export default FinalWindow